import React from "/vendor/react";
import { Route, Redirect } from "/vendor/react-router-dom";

const signinPath = "/signin";

class SigninRedirect extends React.PureComponent {
  renderRedirect = ({ location }) => {
    let queryParams = location.search || "?";

    // Add next path
    if (location.pathname !== signinPath) {
      const newQuery = new URLSearchParams(queryParams);
      queryParams = `?${newQuery.toString()}`;
    }

    return <Redirect to={`${signinPath}${queryParams}`} />;
  };

  render() {
    return <Route render={this.renderRedirect} />;
  }
}

export default SigninRedirect;
